import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import VisibilitySensor from 'react-visibility-sensor';

import Message from './message';


const ChatBox = ({
  t,
  chatId,
  hasMore,
  onRemove,
  loadMore,
  messages,
  onSubmit,
  refs,
  upload_name,
  readMessage,
  unread_count,
  messageToDel,
  chatHasLoaded,
  onScrollChat,
  ...props
}) => (
  <div id="scrl" className="leftinner boxs">
    {
      messages && Object.keys(messages).length
        ? <div
          id="messages-list"
          ref={r => refs.store('listRef', r)}
          className="messenger forscroll2 forscrollmessage"
          onScroll={(e) => { onScrollChat(e); }}
        >
          <InfiniteScroll
            loadMore={loadMore}
            hasMore={hasMore}
            pageStart={0}
            isReverse
            useWindow={false}
            initialLoad={false}
            loader={<div className="loader" key={0}>{t('Loading')} ...</div>}
          >
            {Object.keys(messages).map((key, i) => (
              <React.Fragment key={key} >
                {
                  (Object.keys(messages).length - i === unread_count) &&
                    <VisibilitySensor
                      key="new-msg"
                      offset={{ top: 300 }}
                      onChange={(isVis) => { if (isVis) readMessage(unread_count, chatId); }}
                    >
                      <div className="Newmsgboxs boxs" id="new-msg-line">
                        <div className="newmsg boxs fontmulisemi">
                          <span>{t('New')} </span>
                        </div>
                      </div>
                    </VisibilitySensor>
                }
                <Message
                  item={messages[key]}
                  key={key}
                  messageToDel={messageToDel}
                  onSubmit={onSubmit}
                  onRemove={onRemove}
                  upload_name={upload_name}
                  {...props}
                />
              </React.Fragment>))
            }
          </InfiniteScroll>
          </div>
      : chatHasLoaded
        ? <div className="messenger messenger-emp">{t('Empty chat...')}</div>
        : <div className="messenger messenger-emp">{t('Loading chat...')}</div>
    }
  </div>
);

ChatBox.propTypes = {
  t: PropTypes.func.isRequired,
  messages: PropTypes.object,
};

export default ChatBox;



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/chatBox/ChatBox.jsx